module.exports = __webpack_public_path__ + "img/rob_4wheel.19b7b66e.png";